export default "__VITE_ASSET__BoLgyvs9__"